import { useSelector, useStore } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useRef } from 'react'

import LandingZoneTeamsApi from '../../api/landingZones/teams'

import * as landingZoneTeamsMapping from '../../store/actions/landingZoneTeams'
import * as landingZoneTeamsMappingType from '../../store/actions/landingZoneTeams/types'

import { useNavigate } from 'react-router-dom'
import { useAppSnackbar } from '@services/hooks/AppSnackbar'
import { useAppLoader } from '@services/hooks/AppLoader'
import { useApiError } from '@services/hooks/ApiError'

import { createId } from '@services/utils'
import { generateUrl } from '@services/routes'
import { ROUTE_LANDING_ZONES } from '@features/routes'

import { AZURE, useLandingZones } from '@features/hooks/LandingZones'
import { useLandingZoneMembership } from '@features/hooks/LandingZones/membership'

export const useLandingZoneTeams = () => {
    const store = useStore()
    const dataStore = useSelector(state => state.landingZoneTeams)
    const landingZoneTeamsAction = bindActionCreators(landingZoneTeamsMapping, store.dispatch)

    const { formatMembership } = useLandingZoneMembership()
    const { inLandingZones } = useLandingZones()
    const { hide: hideLoader, show: showLoader } = useAppLoader()
    const { handleError: apiError } = useApiError()
    const { show: showSnack } = useAppSnackbar()
    const navigate = useNavigate()

    const loaderCallback = useRef(null)

    const getData = (index = null) => {
        if (!index) return store.getState().landingZoneTeams
        return store.getState().landingZoneTeams[index]
    }

    const getAzure = (id) => {
        LandingZoneTeamsApi.load(`/api/landing-zones/${id}/teams?expand=true`, AZURE, 'notifications', '/user_impersonation', {'x-api-version': '3.0'}, {
            success: (result) => {
                landingZoneTeamsAction.populate(result?.data.data ?? [], () => {
                    landingZoneTeamsAction.setLoaded(id, format)
                })
            },
            error: (result) => { apiError(result.data.message) }
        })
    }

    const format = () => {
        const raw = getData()
        const grid = []

        for (let i = 0; i < raw.data.length; i++) {
            const item = raw.data[i]

            grid.push({
                id: createId(),
                name: item.displayName ?? '-',
                objectId: item.objectId ?? '-',
                mailNickname: item.mailNickname ?? '-',
                link: item.url ?? null,
                data: formatMembership(item)
            })
        }

        landingZoneTeamsAction.setFormat(grid, landingZoneTeamsMappingType.SET_FORMAT, hideLoader)
    }

    const load = (id, callback = null) => {
        loaderCallback.current = callback

        if (dataStore.loaded === id) return

        landingZoneTeamsAction.setFormat([], landingZoneTeamsMappingType.SET_FORMAT, () => {
            if (!inLandingZones(id)) {
                hideLoader()
                showSnack(`Unknown landing zone`)
                return navigate(generateUrl(ROUTE_LANDING_ZONES))
            }

            showLoader(` `)

            getAzure(id)
        })
    }

    return { load }
}